"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledMainButton = _styledComponents.default.a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-family: ", ";\n  width: 100%;\n  height: 60px;\n  padding: 0 0.5rem 0 0.75rem;\n  border-radius: ", ";\n  background: ", ";\n\n  color: ", ";\n\n  ", ";\n"])), function (p) {
  return p.theme.fontFamilyDefault;
}, function (p) {
  return p.theme.inputBorderRadius;
}, function (p) {
  return p.theme.colorPrimary.includes("#fff") ? p.theme.colorAccent : p.theme.colorPrimary;
}, function (p) {
  return p.theme.colorPrimary.includes("#fff") ? p.theme.colorAccentText : p.theme.colorPrimaryText;
}, function (p) {
  return p.isWhite && "border: 2px solid ".concat(p.theme.colorAccent);
});

var StyledEndPiece = _styledComponents.default.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: block;\n  flex: 0 0 50px;\n  overflow: hidden;\n"])));

var StyledButtonText = _styledComponents.default.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: block;\n  text-align: center;\n  font-size: 1rem;\n  font-family: ", ";\n"])), function (p) {
  return p.theme.fontFamilyDefault;
});

var StyledCtaIcon = _styledComponents.default.img(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: 32px;\n"])));

var StyledMatIcon = _styledComponents.default.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral([""])));

var StyledSvg = _styledComponents.default.svg(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  & path,\n  & ellipse {\n    fill: ", ";\n  }\n"])), function (p) {
  return p.theme.colorPrimary.includes("#fff") ? p.theme.colorAccentText : p.theme.colorPrimaryText;
});

var UFLogo = function UFLogo(_ref) {
  var height = _ref.height,
      width = _ref.width;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledSvg, {
    id: "Group_2102",
    "data-name": "Group 2102",
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 631 604",
    fill: "none",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M272.821 388.152C266.418 424.909 243.612 457.323 191.58 470.252C138.829 483.364 125.988 459.836 132.409 423.079L188.515 103.482L60.9099 135.213L2.66304 467.29C-15.1261 571.604 57.5884 625.965 179.475 595.648C289.24 568.342 376.919 488.156 397.55 369.083L405.323 321.96L578.694 278.847L597.339 167.96L296.945 242.672L272.821 388.152Z",
      fill: "white"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M324.288 76.276L306.105 183.768L612.92 107.459L631 0L324.288 76.276Z",
      fill: "white"
    })]
  });
};

var Low6Button = function Low6Button(_ref2) {
  var ctaUrl = _ref2.ctaUrl,
      ctaText = _ref2.ctaText,
      ctaIconUrl = _ref2.ctaIconUrl;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledMainButton, {
    href: ctaUrl || "https://ultimatefan.com/",
    target: "_blank",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledEndPiece, {
      children: ctaIconUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCtaIcon, {
        src: ctaIconUrl
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(UFLogo, {
        width: "32px",
        height: "32px"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledButtonText, {
      children: ctaText || "Play Ultimate Fan"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledEndPiece, {
      style: {
        textAlign: "right"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledMatIcon, {
        className: "material-icons",
        children: "arrow_forward_ios"
      })
    })]
  });
};

var _default = Low6Button;
exports.default = _default;